module.exports = __webpack_public_path__ + "static/media/Monday_Step2_Image17.513ed122.webp";